export const vi = {
  title: 'Nhật ký hoạt động',
  description:
    'Ai đã làm gì, trên đối tượng nào, khi nào và từ đâu. Nhật ký chỉ ghi thêm, không sửa hay xoá được.',
  actor: 'Người thực hiện',
  allActors: 'Mọi người',
  system: 'Hệ thống',
  module: 'Phân hệ',
  allModules: 'Mọi phân hệ',
  search: 'Tìm hành động hoặc mã đối tượng…',
  from: 'Từ ngày',
  to: 'Đến ngày',
  time: 'Thời gian',
  action: 'Hành động',
  object: 'Đối tượng',
  details: 'Chi tiết',
  changes: 'Nội dung thay đổi',
  noChanges: 'Không có chi tiết',
  ip: 'Địa chỉ IP',
  userAgent: 'Trình duyệt',
  code: 'Mã hành động',
  loadMore: 'Xem thêm',
  empty: 'Không có hoạt động phù hợp',
  loadError: 'Không tải được nhật ký',
  retry: 'Thử lại',
  clear: 'Xoá bộ lọc',
  deletedUser: 'Người dùng đã xoá',
};

export const en: typeof vi = {
  title: 'Activity log',
  description: 'Who did what, to which object, when and from where. The log is append-only.',
  actor: 'Actor',
  allActors: 'Everyone',
  system: 'System',
  module: 'Module',
  allModules: 'All modules',
  search: 'Search actions or object id…',
  from: 'From',
  to: 'To',
  time: 'Time',
  action: 'Action',
  object: 'Object',
  details: 'Details',
  changes: 'Changes',
  noChanges: 'No details',
  ip: 'IP address',
  userAgent: 'Browser',
  code: 'Action code',
  loadMore: 'Load more',
  empty: 'No matching activity',
  loadError: 'Could not load the log',
  retry: 'Retry',
  clear: 'Clear filters',
  deletedUser: 'Deleted user',
};
